module.exports = __webpack_public_path__ + "img/service-img.448f58e5.png";